/* src/app/shared-module/components/user-login-dialog/user-login-dialog.component.scss */
ion-button {
  --background: #e35655 !important;
  text-transform: initial;
  border-radius: 0px;
}
.submit-button {
  color: white;
}
form {
  text-align: end;
  margin-top: 10px;
}
mat-divider {
  border-top-color: black !important;
  border-top-width: 1.5px;
}
.divider-top {
  padding-top: 14px;
}
ion-icon {
  font-size: 20px;
  margin-top: 0px;
}
.title {
  margin-left: 5px;
}
ion-row {
  padding: 10px 0px 4px 0px;
}
/*# sourceMappingURL=user-login-dialog.component.css.map */
